import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import LabelInput from 'components/sales/Input/labelInput/labelInput';
import { handleCommonValidator } from 'constants/objValues/objectValidator';
import FileUpload from 'components/sales/fileUpload/fileUpload';

const ShippedTo = ({
  locationPinCode,
  pincodeData,
  handleValue,
  sameAsBillTo,
  leadData,
  prefilledData,
  documentUploadUrl,
  clientBrd = ''
}) => {
  const [isInputError, setIsInputError] = useState({ pinError: false });
  const locationInput = {
    shipPinCode: '',
    shipGeoCity: '',
    shipGeoState: '',
    shipGeoCityId: '',
    shipGeoStateId: '',
    shipPinId: '',
    shipAddressLine1: '',
    shipAddressLine2: '',
    shipFileUpload: '',
  };
  const [locationData, setlocationData] = useState(locationInput);
  const handlePinBlur = () => {
    if (
      Regex.pinCode.test(locationData.shipPinCode) &&
      !isNaN(locationData.shipPinCode)
    ) {
      locationPinCode(locationData.shipPinCode);
      setIsInputError({ ...isInputError, pinError: '' });
      return false;
    } else {
      setIsInputError({ ...isInputError, pinError: true });
      setlocationData({ ...locationData, shipGeoCity: '', shipGeoState: '' });
    }
  };

  useEffect(() => {
    if (
      prefilledData?.ship_to !== undefined &&
      prefilledData?.ship_to !== null
    ) {
      const {
        file_upload,
        address_line_1,
        address_line_2,
        geo_state_id,
        geo_city_id,
        geo_pin_code,
        geo_state,
        geo_city,
        geo_pin
      } = prefilledData?.ship_to;

      setTimeout(() => {
        setlocationData({ 
          ...locationData,
          shipPinCode: geo_pin.toString(),
          shipGeoCity: geo_city,
          shipGeoState: geo_state,
          shipGeoCityId: geo_city_id,
          shipGeoStateId: geo_state_id,
          shipPinId: geo_pin_code,
          shipAddressLine1: address_line_1,
          shipAddressLine2: address_line_2,
          shipFileUpload:(file_upload!=undefined && file_upload!="undefined" && file_upload!=null && file_upload!="null")?file_upload:(clientBrd!="\"\"" && clientBrd!="\"null\"")?clientBrd:null,
        });
      }, 100);
    }
  }, [prefilledData]);

  useEffect(() => {
    if (sameAsBillTo) {
      const shipObj = {
        shipPinCode: sameAsBillTo.billPinCode,
        shipGeoCity: sameAsBillTo.billGeoCity,
        shipGeoState: sameAsBillTo.billGeoState,
        shipGeoCityId: sameAsBillTo.billGeoCityId,
        shipGeoStateId: sameAsBillTo.billGeoStateId,
        shipPinId: sameAsBillTo.billPinId,
        shipAddressLine1: sameAsBillTo.billAddressLine1,
        shipAddressLine2: sameAsBillTo.billAddressLine2,
      };
      setlocationData(shipObj);
    }
  }, [sameAsBillTo]);

  useEffect(() => {
    if (locationData.shipPinCode.length) {
      if (pincodeData.length) {
        let {
          city_name,
          state_name,
          geo_city_id,
          geo_state_id,
          pincode_id,
        } = pincodeData[0];
        setlocationData({
          ...locationData,
          shipGeoStateId: geo_state_id,
          shipGeoCityId: geo_city_id,
          shipGeoCity: city_name,
          shipGeoState: state_name,
          shipPinId: pincode_id,
        });
      } else {
        setlocationData({ ...locationData, shipGeoState: '', shipGeoCity: '' });
        alert('pin code is not available');
      }
    }
  }, [pincodeData]);
  useEffect(() => {
    const shipObj = {
      shipPinCode: locationData.shipPinCode,
      shipGeoCity: locationData.shipGeoCity,
      shipGeoState: locationData.shipGeoState,
      shipGeoCityId: locationData.shipGeoCityId,
      shipGeoStateId: locationData.shipGeoStateId,
      shipPinId: locationData.shipPinId,
      shipAddressLine1: locationData.shipAddressLine1,
      shipFileUpload: locationData.shipFileUpload
    };
    const isNotEmpty = handleCommonValidator(shipObj,'shipFileUpload');
    if (isNotEmpty !== false) {
      handleValue({
        ...shipObj,
        shipAddressLine2: locationData.shipAddressLine2,
      });
    } else {
      handleValue(null);
    }
  }, [locationData]);
  console.log('location -- ' + JSON.stringify(locationData));

  return (
    <Fragment>
    <FormSection title={localization.shippedTo}>
      <ConstantInput
        label={localization.clientAprtname}
        value={leadData}
        disabled
      />
      <LabelInput
        label={localization.pinCode}
        errorMsg={localization.pinError}
        isError={isInputError.pinError}
        inputValue={locationData.shipPinCode}
        type="text"
        maxLength={6}
        minLength={4}
        onBlur={handlePinBlur}
        handleChange={(e) =>
          setlocationData({ ...locationData, shipPinCode: e.target.value })
        }
        className={locationData.shipPinCode.length ? '' : 'empty'}
        required
        isStarRequired={true}
      />
      <ConstantInput
        label={localization.geoState}
        value={locationData.shipGeoState}
        disabled
      />
      <ConstantInput
        label={localization.geoCity}
        value={locationData.shipGeoCity}
        disabled
      />
      <ConstantInput
        label={localization.addressLine1}
        required
        isStarRequired={true}
        errorMsg={localization.requiredaddress}
        handleChange={(val) =>
          setlocationData({ ...locationData, shipAddressLine1: val })
        }
        value={locationData.shipAddressLine1}
      />
      <ConstantInput
        label={localization.addressLine2}
        handleChange={(val) =>
          setlocationData({ ...locationData, shipAddressLine2: val })
        }
        value={locationData.shipAddressLine2}
      />
    </FormSection>
     <FormSection title={localization.clientBrd}>
      {/* {console.log(locationData.shipFileUpload)} */}
      {/* {console.log("dffdd "+JSON.stringify(clientBrd))} */}
          <div className="form-group">
              <FileUpload
                  id="filDoc"
                  accept=".pdf,.png,.jpg"
                  documentUploadUrl={documentUploadUrl}
                  prefilledFilename={locationData.shipFileUpload}
                  onChange={(val) => setlocationData({
                    ...locationData,
                    shipFileUpload: val,
                  })}
                  // required
              >
                <span className="btn btn-transparent">
                  {localization.clientBrd}
                  {/* <span className="label-star" style={{ color: 'red' }}>
                  &nbsp; *
                </span> */}
                </span>
              </FileUpload>
              &nbsp;
            {/* <label
              className={`error ${clientBrd === null ? 'error-block' : ''}`}
            >
              {localization.pleaseUploadBrd}
            </label> */}
          </div>
     </FormSection>
     </Fragment>
  );
};

ShippedTo.propTypes = {
  locationPinCode: PropTypes.func,
  pincodeData: PropTypes.any,
  handleValue: PropTypes.func,
};

export default ShippedTo;
